import { type Enum } from '@webapp/infrastructure/types/Enum'

// Backend export-type identifiers posted to <endpointBase>/export/ and used as
// the ?type= filter on /api/v3/export-tasks/ and /api/v3/export-formats/.
// Module-scoped subset of the backend export-type space (reports exports 9/10
// live in modules/reports; legacy 30/31 stay in the deprecated enum).
export const ExportTypes = {
  ORDER_ITEMS: 0, // 'Order Items'
  PO_ITEMS: 1, // 'PO Items' (Purchase order items)
  EXPENSE_REPORT_HISTORY: 2, // 'Expense Report History'
  TRAVEL_HISTORY: 3, // 'Travel History'
  BUDGET: 4, // 'Budget' (legacy, pre flexible-spend-tracking)
  RECEIVING_HISTORY: 5, // 'Receiving History'
  CATALOG: 6, // 'Catalog'
  BILLS: 8, // 'Bills'
  USERS: 12, // 'Users'
  LOCATIONS: 13, // 'Locations'
  UNBILLED_PO_ITEMS: 14, // 'Unbilled PO Items' (Accruals Report)
  SPENDING_CARD_TRANSACTIONS: 15, // 'Spending Card Transactions'
  BUDGET_CATEGORIES: 24, // 'Budget Categories' / redesigned 'Budgets'
  IMPORT_LOG: 25, // 'Import Log' (superuser)
  ADMIN_AUDIT_LOG: 26, // 'Admin Audit Log' (superuser)
  CATEGORY_SPEND_DATA: 27, // 'Category Spend Data' / 'Budgets Spend Breakdown'
  CONTRACTS: 28, // 'Contracts'
  RECEIVE_LOG: 29, // 'Receive Log'
  SUPERUSER_AUDIT_LOG: 32, // 'Superuser Audit Log' (superuser)
} as const

export type ExportType = Enum<typeof ExportTypes>
